import DepositOverdraftInterestSettings from "@/models/Products/ProductSettings/DefaultSettings/OverdraftInterest/DepositOverdraftInterestSettings";

export default class AccountDepositOverdraftInterestSettings extends DepositOverdraftInterestSettings {
    overridden: boolean = false;
}